// extracted by mini-css-extract-plugin
export default {"backButton":"UsersByTeam_backButton__H+9e8","teamName":"UsersByTeam_teamName__lzmHU"};